import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from '../shared/google-tag-manager.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';

@Component({
  selector: 'app-bdb-regulation-products',
  templateUrl: './bdb-regulation-products.component.html',
  styleUrls: ['./bdb-regulation-products.component.scss']
})
export class BdbRegulationProductsComponent implements OnInit, AfterViewInit {

  @Input() checkRegulationProducts = false;
  constructor(
    private bdbSessionStorageService: BdbSessionStrgService,
    private googleTagManagerService: GoogleTagManagerService,
    private routes: Router
    ) { }

  ngOnInit() {
    this.googleTagManagerService.sendInfo(window.location.pathname, 'Manejo firmas');
    this.verifyIfUserHasAlreadyAcceptedTACs();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      window.scrollTo(0, window.screenTop);
    }, 1);
  }

  valCheck() {
    this.checkRegulationProducts = !this.checkRegulationProducts;
    const checkRegulationProductsStringValue = this.checkRegulationProducts ? 'true' : 'false';
    this.bdbSessionStorageService.save(SessionStorageKeysEnum.USER_ACCEPTED_TAC, checkRegulationProductsStringValue);
  }

  returnIdentityNumber() {
    this.routes.navigate(['']);
  }

  optionBack() {
    this.routes.navigate([history.back()]);
  }

  scrollToBottom() {
    window.scroll(0, 100000);
  }

  public scrollDownDocument() {
    const scrollDownFunction = function (element, to, duration) {
      if (duration <= 0) {
        return;
      }
      const difference = to - element.scrollTop;
      const perTick = difference / duration * 10;

      setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) {
          return;
        }
        scrollDownFunction(element, to, duration - 10);
      }, 10);
    };
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      // works in Safari
      scrollDownFunction(document.body, document.body.scrollHeight, 900);
    } else {
      // works in Chrome + Firefox
      scrollDownFunction(document.documentElement, document.body.scrollHeight, 900);
    }
  }

  private verifyIfUserHasAlreadyAcceptedTACs() {
    const userAcceptedTAC = this.bdbSessionStorageService.get(SessionStorageKeysEnum.USER_ACCEPTED_TAC);
    this.checkRegulationProducts = userAcceptedTAC === 'true';
  }
}



// WEBPACK FOOTER //
// ./src/app/bdb-regulation-products/bdb-regulation-products.component.ts